import React from "react";
import Header from "./Header";
import Footer from "./Footer";
import CookieBanner from "./CookieBanner";
import { Outlet, useNavigate } from "react-router-dom";
import { useAuth } from "../context/AuthContext";
import useInactivityLogout from "../hooks/useInactivityLogout";
import { toast } from "sonner";
import { useLang } from "../context/LangContext";

export default function Layout({ withHeader = true }) {
  const { user, logout, refresh } = useAuth();
  const { t } = useLang();
  const navigate = useNavigate();

  useInactivityLogout({
    enabled: !!user,
    onTimeout: async () => {
      await logout();
      toast(t("common.sessionExpired"));
      navigate("/login");
    },
    onActivity: () => {
      if (user) refresh();
    },
  });

  return (
    <div className="App min-h-screen flex flex-col bg-background">
      {withHeader && user && <Header />}
      <main className="flex-1 w-full">
        <Outlet />
      </main>
      <Footer />
      <CookieBanner />
    </div>
  );
}
